import Spacer from '@/common/components/spacer';
import { cn } from '@/shadcn-ui/utils';

interface InventoryNoResultFoundProps {
  className?: string;
}

export default function InventoryNoResultFound({
  className,
}: InventoryNoResultFoundProps) {
  return (
    <div
      className={cn(
        'mb-[24px] flex h-fit w-full flex-col items-center justify-center rounded-[16px] border-[1px] border-dashed border-flexcar-neutral60 bg-flexcar-neutral100/20 px-[24px] py-[80px] backdrop-blur-[12px] lg:mb-0',
        className
      )}
    >
      {/* Title */}
      <h3 className="text-flexcar-neutral1">No exact matches</h3>
      <Spacer variant="height16" />
      {/* Description */}
      <p className="body text-center text-flexcar-neutral1">
        Try adjusting your filters to find more options or check out similar results
        below.
      </p>
    </div>
  );
}
